//Franchise
import React from "react";
import Seo from "../components/modules/Seo";
import Franchisefrom from "../components/modules/Franchiseform";
import Franchisepage from "../components/modules/Franchisepage";

const objSeo = {
  title: "Franchise Opportunities | Bit Byte Foods Idly Dosa Batter",
  keywords:
    "Bit Byte Foods franchise, idly dosa batter franchise, food business opportunity, Bagalkot, Karnataka, franchise partner",
  pathSlug: "/franchise",
  baseUrl: "https://bitbytefoods.com/",
  description:
    "Partner with Bit Byte Foods and bring authentic, all-natural idly dosa batter to your city. Explore our franchise benefits and apply today.",
};

const Franchise = () => {
  return (
    <div>
      <Seo data={objSeo} />
      <Franchisepage/>
      <Franchisefrom/>
    </div>
  );
};

export default Franchise;
